export interface XapiHandlers {
    onAnswer?: (result: unknown) => void;
    onInteract?: () => void;
    onSubmit?: (result: unknown) => void;
    onComplete?: (result: unknown) => void;
}

/** Map an H5P xAPI statement to the host callbacks (verb match is by substring). */
export function routeXapiStatement(statement: unknown, h: XapiHandlers): void {
    const stmt = statement as { verb?: { id?: string }; result?: unknown };
    const verbId = stmt?.verb?.id;
    if (verbId?.includes('answered')) {
        h.onAnswer?.(stmt.result);
    } else if (verbId?.includes('completed')) {
        h.onComplete?.(stmt.result);
    } else if (verbId?.includes('submitted') || verbId?.includes('scored')) {
        h.onSubmit?.(stmt.result);
    } else if (verbId?.includes('interacted')) {
        h.onInteract?.();
    }
}
